import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import { INDENT_MIS } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';


class IndentMis extends Component {

    state = {
        isLoading: true
    }


    componentDidMount() {
        const { dispatch } = this.props;
        const user = getUser();
        const companyId = (user && user.companyId) ? user.companyId : '';
        dispatch({
            type: INDENT_MIS,
            params: {
                companyId: companyId,
            }
        })
    }

    render() {
        const { embedCode, token } = this.props;
        return (
            <Sticky>
                { this.state.isLoading && <ActionLoader /> }
                {token &&
                    <iframe
                        src={"https://secure.holistics.io/embed/" + embedCode + "?_token=" + token}
                        style={{ width: "100%", height: 600 }}
                        frameBorder="0"
                        onLoad={() => { this.setState({ isLoading: false }) }}
                        title="Indent Mis"
                        allowFullScreen>
                    </iframe>
                }
            </Sticky>
        );
    }
    
}

const mapStateToProps = ({constants}) => {
  return {
    token: constants.holistics.token,
    embedCode: constants.holistics.embedCode,
  }
};

export default connect(mapStateToProps)(IndentMis);

